import CopyClipboard from '@/components/copy-clipboard/copy-clipboard';
import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';
import { isEmptyValue } from '@/utils/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
   name: 'navigator-search-index',
   components: {
      'copy-clipboard': CopyClipboard,
   },
})

export default class NavigatorSearchIndex extends Vue {

   public routerPage = {
      path: '/partner-catalog/partners-list',
      query: { activeComponent: 'curriculum-provider-detail', partnerId: '' },
   };

   public navigatorIndexAPIs: any = [
      {
         method: 'post',
         url: '/api/content/v1/ingest',
         description: 'It create interfaces to enable the Content Providers to ingest content into the Navigator.',
         requestPayload: {
            content: [
               {
                  action: 'update',
                  id: '343442343',
                  title: 'What Is Energy',
                  description: 'It Comes From Many Sources And In Many Forms. The Forms Of Energy Are Classified In Two General Categories: Potential And Kinetic.',
                  url: 'http://energy4me.org/all-about-energy/what-is-energy/energy-sources/coal/',
                  isCurated: true,
                  author: {
                     firstname: 'a',
                     lastname: 'b',
                     id: '12345',
                  },
                  competency: [
                     {
                        fw: 'CCSS',
                        subjectCode: 'K12.MA',
                        competency: 'RL.K.6',
                     },
                  ],
                  contentFormat: 'webpage_resource',
                  metadata: {
                     audience: [
                        'All students',
                        'Teachers',
                     ],
                     educational_use: 'Reference Material',
                     advertisement_level: 'No Advertisement',
                     reading_level: [
                        'Kindergarten',
                        '1',
                     ],
                     license: 'Copyrighted',
                     depth_of_knowledge: 'Level 1: Recall',
                  },
                  productId: 123,
                  etlInSecs: 4000,
                  isFrameBreaker: true,
                  contentQualityIndicator: 4,
                  publisherQualityIndicator: 5,
                  keywords: [
                     'energy',
                     'science',
                  ],
               },
               {
                  action: 'insert',
                  id: '2342442343',
                  title: 'Counting and Cardinality',
                  description: 'It Comes From Many Sources And In Many Forms. The Forms Of Energy Are Classified In Two General Categories: Potential And Kinetic.',
                  url: 'http://math.org/cc/what-are-numbers/counts/real/',
                  isCurated: true,
                  author: {
                     firstname: 'a',
                     lastname: 'b',
                     id: '12345',
                  },
                  competency: [
                     {
                        fw: 'CCSS',
                        subjectCode: 'K12.MA',
                        competency: 'RL.K.6',
                     },
                  ],
                  contentFormat: 'webpage_resource',
                  metadata: {
                     audience: [
                        'All students',
                        'Teachers',
                     ],
                     educational_use: 'Reference Material',
                     advertisement_level: 'No Advertisement',
                     reading_level: [
                        'Kindergarten',
                        '1',
                     ],
                     license: 'Copyrighted',
                     depth_of_knowledge: 'Level 1: Recall',
                  },
                  productId: 123,
                  etlInSecs: 4000,
                  isFrameBreaker: true,
                  contentQualityIndicator: 4,
                  publisherQualityIndicator: 5,
                  keywords: [
                     'energy',
                     'science',
                  ],
               },
               {
                  action: 'delete',
                  id: '2342442343',
               },
            ],
         },
      },
      {
         method: 'post',
         url: '/api/content/v1/ingest/{requestId}/details',
         description: 'It create interfaces to enable the Content Providers to ingest content into the Navigator.',
         requestPayload: 'Request Id that has been received from content ingest API response',
      },
   ];

   public navigatorSecret = {
      clientId: '',
      secretCode: '',
   };

   // ----------------------------------------------------------
   // Properties
   @Prop()
   public activeToolData: any;

   public mounted() {
      this.getCreatedOAuth();
   }

   public onNewSecret() {
      const payload = {
         client_id: this.activeToolData.toolData.clientId,
         client_secret: this.activeToolData.toolData.clientCode,
      };
      adminUtilsAPI.fetchOAthClientSecret(payload).then((data: any) => {
         this.navigatorSecret.clientId = data.client_id;
         this.navigatorSecret.secretCode = data.client_secret;
      });
      // }
   }

   public clickToRoute() {
      this.routerPage.query.partnerId = this.activeToolData.partnerId;
      this.$router.push(this.routerPage);
   }

   public getCreatedOAuth() {
      const tenantId = this.activeToolData.toolData && this.activeToolData.toolData.tenantId ?
      this.activeToolData.toolData.tenantId : '' ;
      const params = {
         tenant_id: tenantId,
         partner_id: this.activeToolData.partnerId,
      };
      if (!isEmptyValue(tenantId) && this.activeToolData.partnerId) {
         adminUtilsAPI.fetchOAuthConfig(params).then((dataResp: any) => {
            if (dataResp && dataResp.length > 0) {
               const data = dataResp[0];
               this.navigatorSecret.clientId = data.client_id;
               this.navigatorSecret.secretCode = data.client_secret;
            }
         });
      }
   }
}

